import { setOwner } from '@ember/application';
import type Owner from '@ember/owner';

// use this class when needs application context to use @services etc.

export default class Serviced {
	// gets injected in service-hub
	static appInstance: Owner;

	declare container: unknown;

	constructor() {
		setOwner(this, Serviced.appInstance);
	}
}
